function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { numberAndUnit } from '../modules/core/regex.js';
var SVGNumber = /*#__PURE__*/ function() {
    "use strict";
    function SVGNumber() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _class_call_check(this, SVGNumber);
        this.init.apply(this, _to_consumable_array(args));
    }
    _create_class(SVGNumber, [
        {
            key: "convert",
            value: function convert(unit) {
                return new SVGNumber(this.value, unit);
            }
        },
        {
            // Divide number
            key: "divide",
            value: function divide(number) {
                number = new SVGNumber(number);
                return new SVGNumber(this / number, this.unit || number.unit);
            }
        },
        {
            key: "init",
            value: function init(value, unit) {
                unit = Array.isArray(value) ? value[1] : unit;
                value = Array.isArray(value) ? value[0] : value;
                // initialize defaults
                this.value = 0;
                this.unit = unit || '';
                // parse value
                if (typeof value === 'number') {
                    // ensure a valid numeric value
                    this.value = isNaN(value) ? 0 : !isFinite(value) ? value < 0 ? -3.4e38 : +3.4e38 : value;
                } else if (typeof value === 'string') {
                    unit = value.match(numberAndUnit);
                    if (unit) {
                        // make value numeric
                        this.value = parseFloat(unit[1]);
                        // normalize
                        if (unit[5] === '%') {
                            this.value /= 100;
                        } else if (unit[5] === 's') {
                            this.value *= 1000;
                        }
                        // store unit
                        this.unit = unit[5];
                    }
                } else {
                    if (_instanceof(value, SVGNumber)) {
                        this.value = value.valueOf();
                        this.unit = value.unit;
                    }
                }
                return this;
            }
        },
        {
            // Subtract number
            key: "minus",
            value: function minus(number) {
                number = new SVGNumber(number);
                return new SVGNumber(this - number, this.unit || number.unit);
            }
        },
        {
            // Add number
            key: "plus",
            value: function plus(number) {
                number = new SVGNumber(number);
                return new SVGNumber(this + number, this.unit || number.unit);
            }
        },
        {
            // Multiply number
            key: "times",
            value: function times(number) {
                number = new SVGNumber(number);
                return new SVGNumber(this * number, this.unit || number.unit);
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                return [
                    this.value,
                    this.unit
                ];
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.toString();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return (this.unit === '%' ? ~~(this.value * 1e8) / 1e6 : this.unit === 's' ? this.value / 1e3 : this.value) + this.unit;
            }
        },
        {
            key: "valueOf",
            value: function valueOf() {
                return this.value;
            }
        }
    ]);
    return SVGNumber;
}();
// Module for unit conversions
export { SVGNumber as default };
